'use client';

import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps } from 'sonner';
import { useTranslations } from 'next-intl';

const isValidTheme = (value: unknown): value is 'light' | 'dark' | 'system' =>
  value === 'light' || value === 'dark' || value === 'system';

const normalizeTheme = (value: unknown): 'light' | 'dark' | 'system' => {
  return isValidTheme(value) ? value : 'system';
};

const Toaster = ({ theme: themeProp, ...props }: ToasterProps) => {
  const t = useTranslations('WorkspaceShell');
  const { theme: systemTheme } = useTheme();

  const resolvedTheme = normalizeTheme(themeProp ?? systemTheme);

  return (
    <Sonner
      {...props}
      theme={resolvedTheme}
      containerAriaLabel={t('notifications')}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
    />
  );
};

export { Toaster };
